import AuthRoutes from '@/auth/main/routes/AuthRoutes';
import MainRoutes from '@/common/main/routes/MainRoutes';
import DeepLinkRoutes from '@/deep-link/main/DeepLinkRoutes';
import OneTimePaymentRoutes from '@/one-time-payment/main/OneTimePaymentRoutes';
import { createBrowserRouter } from 'react-router-dom';

const router = createBrowserRouter([AuthRoutes, MainRoutes, OneTimePaymentRoutes, DeepLinkRoutes], {
  basename: import.meta.env.VITE_APP_BASE_NAME,
});

export default router;
